<template>
  <v-container id="city-get" class="propostas">
    <city-header :payload="municipio"> </city-header>

    <v-card class="mt-6 rounded-0">
      <v-bottom-navigation color="primary" class="w-100">
        <v-btn
          :to="'/cidade/' + municipioId + '/proposta/proposta'"
          class="flex-grow-1 botao"
          style="max-width: none"
          @click="tab = 'proposta'"
          color="primary"
        >
          <span>Proposta</span>
        </v-btn>
        <v-btn
          v-if="config.verSolucoesExtras && groupsConfig.verSolucoesExtras"
          :to="'/cidade/' + municipioId + '/proposta/solucoesExtra'"
          class="flex-grow-1 botao"
          style="max-width: none"
          color="primary"
          @click="tab = 'solucoesExtra'"
        >
          <span>Solução Extra</span>
        </v-btn>
      </v-bottom-navigation>
    </v-card>
    <v-card class="rounded-0 bg-light inside">
      <div v-if="tab === 'proposta'" class="container-border">
        <Propostas></Propostas>
      </div>
      <div v-if="tab === 'solucoesExtra'" class="container-border">
        <SolucoesExtras></SolucoesExtras>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Propostas from "@/modules/city/components/propostas/Propostas";
import SolucoesExtras from "@/modules/city/components/propostas/solucoesExtras/List";

import CityHeader from "@/modules/city/components/Header";

export default {
  name: "ListaProposta",

  components: {
    CityHeader,
    Propostas,
    SolucoesExtras,
  },
  computed: {
    ...mapGetters(["isFullAdmin", "user", "config", "groupsConfig"]),
    uf() {
      return this.$store.state.uf;
    },
  },
  mounted() {},
  data() {
    return {
      tab: this.$route.params.tab,
      municipio: null,
      municipioId: this.$route.params.id,
    };
  },
  methods: {
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.municipioId)
        .then((resp) => {
          this.municipio = resp.data;

          if (this.municipio.faixaId)
            this.loadFaixasByCity(this.municipio.faixaId);
          else this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados do município");
          console.log("Erro no loadCity ", err);
          this.setLoading(false);
        });
    },
    ...mapActions(["setLoading"]),
  },
};
</script>
<style lang="scss">
.propostas {
  .botao.v-btn:not(.v-btn--active) .v-btn__content {
    color: #a3a3a3 !important;
  }

  .v-btn--active {
    background: var(--corPrimaria) !important;
    color: #fff !important;
  }

  .container-border {
    border: 4px solid var(--corPrimaria);
    padding: 20px;
  }

  .rela {
    margin-right: 10px;
    i {
      color: green !important;
    }
  }
}
</style>
